import { useEffect } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import './App.css';

import Navbar from './layouts/Navbar/Navbar';
import AppRoutes from './routes/AppRoutes';

function App() {
  useEffect(() => {
    // adiciona a fonte Inter
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }, []);

  useEffect(() => {
    const loader = document.getElementById("initial-loader");
    if (loader) {
      loader.remove(); 
    }
  }, []);

  return (
    <Router>
      <AppContent />
    </Router>
  );
}

function AppContent() {
  const location = useLocation();

  const noNavbarRoutes = ['/error', '/access-denied'];
  const hideNavbar = noNavbarRoutes.includes(location.pathname);

  return (
    <div className={`App-layout ${hideNavbar ? 'error-layout' : 'default-layout'}`}>
      {!hideNavbar && <Navbar />}
      <div className={`App-main ${hideNavbar ? 'error-main' : 'default-main'}`}>
        <div className={`App-content ${hideNavbar ? 'error-content' : 'default-content'}`}>
          <AppRoutes />
        </div>
      </div>
    </div>
  );
}

export default App;
